import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { SuggestedSeason } from '../../models/company/suggested-season.type';

@Injectable({
  providedIn: 'root'
})
export class SuggestedSeasonFilterService extends IFilterListService<SuggestedSeason> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<SuggestedSeason>(GetQuery.GET_SUGGESTED_SEASONS_NO_IDS, { search: searchText })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['suggestedSeasons'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<SuggestedSeason>) => {
          let datasource: Array<Selectable<SuggestedSeason>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
